module.exports = __webpack_public_path__ + "static/media/menu.e44e781d.svg";